import { render, staticRenderFns } from "./PlansUpdate.vue?vue&type=template&id=b2ea045c&scoped=true&"
import script from "./PlansUpdate.vue?vue&type=script&lang=js&"
export * from "./PlansUpdate.vue?vue&type=script&lang=js&"
import style0 from "./PlansUpdate.vue?vue&type=style&index=0&id=b2ea045c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ea045c",
  null
  
)

export default component.exports